module.exports = __webpack_public_path__ + "static/media/trunk.eb7caad6.png";